function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null);

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.5-\\u2013-build-[warning]-v2",
  transform: "translate(-463.000000, -442.000000)",
  fill: "#FF4D4D",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "noun_Error_943892",
  transform: "translate(463.000000, 442.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M68.25,48.2391304 L42.7608696,5.09782609 C41.0869565,2.35869565 38.1956522,0.684782609 35,0.684782609 C31.8043478,0.684782609 28.9130435,2.35869565 27.2391304,5.09782609 L1.75,48.2391304 C0.0760869565,50.9782609 0.0760869565,54.4021739 1.67391304,57.1413043 C3.34782609,60.0326087 6.23913043,61.7065217 9.43478261,61.7065217 L60.5652174,61.7065217 C63.7608696,61.7065217 66.7282609,60.0326087 68.326087,57.1413043 C69.923913,54.4021739 69.923913,50.9782609 68.25,48.2391304 Z M65.2826087,55.3913043 C64.2934783,57.0652174 62.5434783,58.1304348 60.6413043,58.1304348 L9.35869565,58.1304348 C7.45652174,58.1304348 5.63043478,57.1413043 4.7173913,55.3913043 C3.72826087,53.7173913 3.72826087,51.6630435 4.7173913,50.0652174 L30.3586957,6.84782609 C31.3478261,5.17391304 33.0978261,4.26086957 35,4.26086957 C36.9021739,4.26086957 38.7282609,5.25 39.6413043,6.84782609 L65.2826087,49.9891304 C66.1956522,51.6630435 66.1956522,53.7173913 65.2826087,55.3913043 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M35,17.1195652 C33.7065217,17.1195652 32.6413043,18.1847826 32.6413043,19.4782609 L32.6413043,38.576087 C32.6413043,39.8695652 33.7065217,40.9347826 35,40.9347826 C36.2934783,40.9347826 37.3586957,39.8695652 37.3586957,38.576087 L37.3586957,19.4782609 C37.3586957,18.1847826 36.2934783,17.1195652 35,17.1195652 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M35,45.2717391 C33.7065217,45.2717391 32.6413043,46.3369565 32.6413043,47.6304348 L32.6413043,48.8478261 C32.6413043,50.1413043 33.7065217,51.2065217 35,51.2065217 C36.2934783,51.2065217 37.3586957,50.1413043 37.3586957,48.8478261 L37.3586957,47.6304348 C37.3586957,46.1847826 36.2934783,45.2717391 35,45.2717391 Z",
  id: "Path"
})))));

const SvgErrorTriangle = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "70px",
    height: "62px",
    viewBox: "0 0 70 62",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgErrorTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error-triangle.bdacc22a.svg";
export { ForwardRef as ReactComponent };